<template>
  <v-select
    label="Seleccionar Empresa"
    outlined
    v-model="empresa"
    item-text="label"
    item-value="value"
    :items="empresas"
    ><template v-slot:selection="data">
      {{ data.item.label | truncate(35) }}
    </template></v-select
  >
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: `SeleccionarEmpresa`,
  data() {
    return {
      items: []
    };
  },
  computed: {
    ...mapGetters(["empresas"]),
    empresa() {
      return this.$store.getters.empresa.ruc;
    }
  }
};
</script>
